export default (string, urlLengthLimit = 30) => {
    const trimUrlString = (url) => {
        if (url.length > urlLengthLimit) {
            return url.substring(0, urlLengthLimit) + '...';
        } else {
            return url;
        }
    }

    //eslint-disable-next-line
    const urlRegex = /https?\:\/\/[a-zA-Z\.\/0-9\=\?\&\-\_]*/g;

    let res = null;
    let _string = string;
    do {
        res = urlRegex.exec(string);
        if (res) {
            _string = _string.replace(res[0], '<a class="StringParserLink" target="_blank" rel="noopener noreferrer" href="' + res[0] + '">' + trimUrlString(res[0]) + '</a>');
        }
    } while (res);

    return _string;
}
